var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        [
          _c(
            "el-main",
            [
              _vm._v("\n            接口访问日志\n            "),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px", align: "center" },
                  attrs: { gutter: 10 }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入搜索内容", clearable: "" },
                        model: {
                          value: _vm.q,
                          callback: function($$v) {
                            _vm.q = $$v
                          },
                          expression: "q"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 2 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: {
                            click: function($event) {
                              return _vm.handleSearch()
                            }
                          }
                        },
                        [_vm._v("搜索")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "margin-top": "10px" },
                  attrs: {
                    stripe: "",
                    data: _vm.tableData,
                    border: "",
                    size: "mini"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "id",
                      label: "#",
                      width: "50"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "username",
                      label: "用户名",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "method",
                      label: "请求方法",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      "show-overflow-tooltip": "",
                      prop: "uri",
                      label: "请求路径",
                      width: "110"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "remoteAddress",
                      label: "源IP",
                      width: "110"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "languageTag",
                      label: "语言"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      "show-overflow-tooltip": "",
                      prop: "headers",
                      label: "请求头"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "center", prop: "status", label: "响应码" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      prop: "localCreateTime",
                      label: "请求时间"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 20, 40, 60, 80, 100],
                  "page-size": _vm.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1260aa70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1260aa70","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/log/httptrace.vue
// module id = null
// module chunks = 